/**
 * Constants for RaiseQueryForm component
 */

export const SLA_DEFAULT_HOURS = 24;

export const QUERY_TYPE_OPTIONS = [
  { value: 'GENERAL', label: 'General' },
  { value: 'TECHNICAL', label: 'Technical' },
  { value: 'FINANCIAL', label: 'Financial' },
  { value: 'OPERATIONAL', label: 'Operational' },
  { value: 'OTHER', label: 'Other' },
];

export const REGION_OPTIONS = [
  // { value: 'ALL', label: 'All' },
  { value: 'NER', label: 'NER' },
  { value: 'NR', label: 'NR' },
  { value: 'WR', label: 'WR' },
  { value: 'SR', label: 'SR' },
  { value: 'ER', label: 'ER' },
  // { value: 'HO', label: 'HO' },
];

export const PRIORITY_OPTIONS = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
];

export const MAX_TOTAL_SIZE = 50 * 1024 * 1024; // 50MB total for all files

export const ALLOWED_FILE_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
  'application/pdf',
  'application/msword',                                                         // .doc
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',     // .docx
  'application/vnd.ms-excel',                                                   // .xls
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',           // .xlsx
  'application/vnd.ms-outlook',                                                 // .msg
];

/**
 * Extension-based fallback for browsers that report application/octet-stream
 * for some file types (e.g. .msg, .docx, .xlsx).
 */
export const EXTENSION_MIME_FALLBACK = {
  '.doc': 'application/msword',
  '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  '.xls': 'application/vnd.ms-excel',
  '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  '.msg': 'application/vnd.ms-outlook',
  '.pdf': 'application/pdf',
  '.jpg': 'image/jpeg',
  '.jpeg': 'image/jpeg',
  '.png': 'image/png',
  '.webp': 'image/webp',
};

export const ALLOWED_EXTENSIONS = Object.keys(EXTENSION_MIME_FALLBACK);

/**
 * Accept string for <input type="file" accept="...">
 */
export const ACCEPTED_FILE_INPUT_TYPES =
  'image/png,image/jpeg,image/jpg,image/webp,.pdf,.doc,.docx,.xls,.xlsx,.msg';

export const ALLOWED_FILE_TYPES_LABEL =
  'PNG, JPG, WEBP, PDF, DOC, DOCX, XLS, XLSX, MSG';
